import moment from 'moment';

export const formatTime = (time, format) => {
  if (!time) return ''; 
  if (!format)
    format = process.env.REACT_APP_DefaultTimeFormat || 'HH:mm'; 
  return moment(time, 'HH:mm').format(format);
};

export default formatTime;
